import {
  Button,
  IconButton,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  useDisclosure,
} from '@chakra-ui/react'
import { generatePath, useNavigate } from 'react-router'
import { Exit } from 'src/components/icon'
import { Paths } from 'src/constants/paths'
import { useVideoCallRoom } from 'src/features/videoCall/context/videoCallRoomContext'

import { useActiveDevice } from '../../context/ExplanationRoomEvent'

type Props = {
  trialUid: string
  isAgreementCompletedOrRejected?: boolean
  isSP?: boolean
}

export const PatientLeaveRoomButton: React.FC<Props> = ({
  trialUid,
  isAgreementCompletedOrRejected,
  isSP = false,
}) => {
  const { isOpen, onOpen, onClose } = useDisclosure()

  const { leave: leaveVideoCallRoom } = useVideoCallRoom()

  const { sendDeleted } = useActiveDevice()

  const navigate = useNavigate()

  const handleLeaveRoom = async () => {
    leaveVideoCallRoom()
    await sendDeleted()
    const path = generatePath(Paths.PatientExplanationRoomFinished, {
      trialUid,
    })
    const queryParam = `?returnUrl=${window.location.href}`
    const fullPath = `${path}${queryParam}`
    navigate(fullPath)
  }

  const titleText = '面談を退出する'

  return (
    <>
      {isSP ? (
        <IconButton
          icon={<Exit />}
          aria-label={titleText}
          colorScheme="red"
          variant="solid"
          minW="unset"
          boxSize="28px"
          onClick={onOpen}
        />
      ) : (
        <Button colorScheme="red" variant="outline" onClick={onOpen}>
          {titleText}
        </Button>
      )}

      <Modal
        isOpen={isOpen}
        onClose={onClose}
        variant={isSP ? 'sp' : 'normal'}
        size="xl"
      >
        <ModalOverlay />
        <ModalContent>
          <ModalCloseButton />
          <ModalHeader>{titleText}</ModalHeader>
          <ModalBody>
            {!isAgreementCompletedOrRejected && (
              <Text>同意は完了していません。面談を退出しますか？</Text>
            )}
          </ModalBody>
          <ModalFooter>
            <Button
              size={isSP ? 'sp' : 'md'}
              onClick={onClose}
              colorScheme="green"
            >
              面談を継続する
            </Button>
            <Button
              size={isSP ? 'sp' : 'md'}
              colorScheme="red"
              variant="solid"
              onClick={handleLeaveRoom}
            >
              退出する
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}
